import { Link } from 'react-router-dom';
import { articles, siteInfo } from '@/mocks/incidents';

export default function HeroSection() {
  const featured = articles.filter((item) => item.featured);
  const lead = featured[0] ?? articles[0];
  const secondary = articles.filter((item) => item.id !== lead.id).slice(0, 4);

  return (
    <section className="relative w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-8 md:px-6 md:py-12">
        <div className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5 font-medium text-primary-600">
            <i className="ri-flag-line"></i>
            编辑部精选
          </span>
          <span className="hidden sm:inline">·</span>
          <span>围绕公开报道与通报整理，按时间线持续更新</span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <article className="group relative overflow-hidden rounded-xl lg:col-span-7">
            <Link to={`/cases/${lead.id}`} className="block">
              <div className="relative h-[320px] w-full overflow-hidden bg-foreground-900 md:h-[440px]">
                <img
                  src={lead.cover}
                  alt={`${lead.title} 配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/45 to-foreground-950/5"></div>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
                  <span className="inline-flex items-center rounded-sm bg-primary-600 px-2.5 py-1 text-[11px] font-medium text-background-50">
                    {lead.category}
                  </span>
                  <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                    {lead.title}
                  </h2>
                  <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-200 md:line-clamp-2">
                    {lead.summary}
                  </p>
                  <div className="mt-4 flex flex-wrap items-center gap-4 text-[11px] text-background-300">
                    <span className="flex items-center gap-1">
                      <i className="ri-map-pin-line"></i>
                      {lead.region}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {lead.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {lead.readMinutes} 分钟阅读
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </article>

          <div className="flex flex-col gap-5 lg:col-span-5">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
                  <i className="ri-list-ordered text-primary-600"></i>
                  今日关注
                </h3>
                <Link to="/cases" className="flex items-center gap-1 text-[11px] text-foreground-500 transition-colors hover:text-primary-600">
                  全部
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
              <ul className="mt-4 divide-y divide-background-200">
                {secondary.map((item, index) => (
                  <li key={item.id}>
                    <Link to={`/cases/${item.id}`} className="group flex items-start gap-3 py-3 first:pt-0 last:pb-0">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-sm bg-accent-100 font-heading text-[11px] font-bold text-accent-800">
                        {index + 1}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="line-clamp-2 block text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                          {item.title}
                        </span>
                        <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                          <span>{item.category}</span>
                          <span>·</span>
                          <span>{item.date}</span>
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-xl bg-foreground-950 p-5 text-background-100 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-background-50">
                <i className="ri-shield-cross-line text-accent-400"></i>
                反诈快速自查
              </h3>
              <ul className="mt-3 space-y-2 text-xs leading-relaxed text-background-200">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-blank-circle-fill mt-1 text-[6px] text-accent-500"></i>
                  境外岗位能否说明具体雇主与工作内容？
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-blank-circle-fill mt-1 text-[6px] text-accent-500"></i>
                  对方是否要求上交证件或保管护照？
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-blank-circle-fill mt-1 text-[6px] text-accent-500"></i>
                  是否被要求先到边境城市再统一「出境」？
                </li>
              </ul>
              <Link
                to="/cases?category=%E8%AD%A6%E7%A4%BA%E7%A7%91%E6%99%AE"
                className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-accent-400 transition-colors hover:text-accent-300"
              >
                查看警示科普
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>

        <p className="mt-6 text-[11px] leading-relaxed text-foreground-400">
          {siteInfo.name} · {siteInfo.description}
        </p>
      </div>
    </section>
  );
}